module.exports = __webpack_public_path__ + "static/media/Asset 10@3x.d2de46ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Avatar/Asset 10@3x.png
// module id = 2406
// module chunks = 0